<template>
  <div :id="this.getId" style="background-color: #000">
    <div class="wrapper">
      <div :id="this.getProgressBarId" class="progress-bar" data-percent="0">
        <div class="progress">
          <div :id="this.getProgressFillId" class="progress-fill"></div>
        </div>
        <div class="percents">
          <div class="percents-wrapper">
            <span :id="this.getPercentsSpanId">%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "CircleProgress",
  props: ["value", "id"],
  components: {},
  data: function () {
    return {
      isAnimating: false,
      pb: null,
      percent: 0,
      deg: 0,
    };
  },
  watch: {
    value(newVal /*, oldVal*/) {
      this.set(newVal);
    },
  },
  mounted() {
    this.pb = $("#" + this.getProgressBarId);
    this.percent = this.value;
    let percent = this.percent;
    if (100 < percent) {
      percent = 100;
    }
    this.deg = (360 * percent) / 100;
    this.isAnimating = false;
    $("#" + this.getProgressBarId).fadeIn();
    if (percent > 50) {
      this.pb.addClass("next-part");
    }
    $("#" + this.getProgressFillId).css(
      "transform",
      "rotate(" + this.deg + "deg)"
    );
    if (100 < this.percent) {
      $("#" + this.getPercentsSpanId).html("NO SPACE");
    } else {
      $("#" + this.getPercentsSpanId).html(percent + "%");
    }
  },
  computed: {
    getId() {
      return "circle-progress-" + this.id;
    },
    getProgressBarId() {
      return "progress-bar-" + this.getId;
    },
    getProgressFillId() {
      return "progress-fill-" + this.getId;
    },
    getPercentsSpanId() {
      return "percents-span-" + this.getId;
    },
  },
  methods: {
    update(newPercent) {
      if (!this.isAnimating) {
        this.isAnimating = true;
        var interval = setInterval(
          function () {
            this.percent += 1;
            this.deg += 3.6;
            if (this.percent > 50) {
              this.pb.addClass("next-part");
            }
            $("#" + this.getProgressFillId).css(
              "transform",
              "rotate(" + this.deg + "deg)"
            );
            $("#" + this.getPercentsSpanId).html(this.percent + "%");
            if (this.percent >= newPercent) {
              clearInterval(interval);
              this.isAnimating = false;
            }
          }.bind(this),
          30
        );
      }
    },
    set(newPercent) {
      this.pb.removeClass("next-part");
      if (100 < newPercent) {
        this.percent = 100;
      } else {
        this.percent = newPercent;
      }
      this.deg = (360 * this.percent) / 100;
      this.isAnimating = false;
      $("#" + this.getProgressBarId).fadeIn();
      if (this.percent > 50) {
        this.pb.addClass("next-part");
      }
      $("#" + this.getProgressFillId).css(
        "transform",
        "rotate(" + this.deg + "deg)"
      );
      if (100 < newPercent) {
        $("#" + this.getPercentsSpanId).html("NO SPACE");
      } else {
        $("#" + this.getPercentsSpanId).html(this.percent + "%");
      }
    },
  },
};
</script>
<style scoped>
.wrapper {
  margin: 50px auto 0px;
  position: relative;
  height: 150px;
  background-color: #000;
}

.progress-bar {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: white;
  margin: 50px auto 0;
}

.progress {
  max-height: 650px;
  content: "";
  position: absolute;
  border-radius: 50%;
  left: calc(50% - 100px);
  top: calc(50% - 100px);
  width: 200px;
  height: 200px;
  clip: rect(0, 200px, 200px, 100px);
  background-color: white;
}

.progress-bar.next-part {
  background-color: lightskyblue;
}

.next-part .progress {
  clip: rect(0, 100px, 200px, 0);
}
.progress .progress-fill {
  content: "";
  position: absolute;
  border-radius: 50%;
  left: calc(50% - 100px);
  top: calc(50% - 100px);
  width: 200px;
  height: 200px;
  clip: rect(0, 100px, 200px, 0);
  background: lightskyblue;
  transform: rotate(60deg);
}
.percents {
  content: "";
  position: absolute;
  border-radius: 50%;
  left: calc(50% - 173.9130434783px / 2);
  top: calc(50% - 173.9130434783px / 2);
  width: 173.9130434783px;
  height: 173.9130434783px;
  background: black;
  text-align: center;
  display: table;
}

.percents-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.percents span {
  display: block;
  font-size: 2.6em;
  /* font-weight: bold; */
  color: lightskyblue;
}
</style>
